module.exports = __webpack_public_path__ + "static/media/nidalee.9baa189e.png";